//npm packages
import React, { memo } from 'react';
import { Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';

//redux actions
import { historyList } from '../../redux/actions';

//elements starts with capital letter
import { GridBase } from '../../components';

//helper files
import strings from '../../globalization';

const HistoryList = memo(props => {
  const { params } = props.match;
  const history = useHistory();

  const advanceButtons = (
    <Button
      title={strings.Back}
      type="button"
      color="secondary"
      onClick={() => history.goBack()}
      style={{ float: 'right' }}
    >
      {' '}
      <FontAwesomeIcon icon={faBackward}></FontAwesomeIcon> {strings.Back}
    </Button>
  );

  const columns = [
    { key: 'TableName', name: strings.TableName, width: 150, sortable: false },
    {
      key: 'FieldName',
      name: strings.FieldUpdated,
      width: 150,
      sortable: true
    },
    {
      key: 'OldValue',
      name: strings.OriginalValue,
      width: 200,
      mode: 'remote',
      store: 'OldValue',
      valueProp: '_id',
      displayValue: 'DisplayValue',
      sortable: true
    },
    {
      key: 'NewValue',
      name: strings.NewValue,
      width: 200,
      mode: 'remote',
      store: 'NewValue',
      valueProp: '_id',
      displayValue: 'DisplayValue',
      sortable: true
    },
    {
      key: 'updatedAt',
      name: strings.updatedAt,
      type: 'date',
      renderer: 'date-time',
      hidden: false,
      width: 150,
      sortable: true
    },
    {
      key: 'ModifiedBy',
      name: strings.UpdatedBy,
      hidden: false,
      width: 150,
      mode: 'remote',
      store: 'User',
      valueProp: '_id',
      displayValue: 'UserName',
      sortable: true
    }
  ];
  return (
    <GridBase
      {...props}
      key={Math.random()}
      columns={columns}
      action={historyList}
      title={strings.History}
      showAddButton={false}
      dataProperty="historyListData"
      comboType={['NewValue', 'OldValue', 'User']}
      baseFilter={{ RecordId: params.id }}
      disableFilter={true}
      disableShowHideColumns={true}
      CustomButtons={advanceButtons}
      loadPref={true}
      listId="History"
    />
  );
});
export default HistoryList;
